module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activityLocationSearch"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Location')))]), _vm._v(" "), _c('v-select', {
    staticClass: "vSelect",
    attrs: {
      "label": ("name_" + _vm.language),
      "placeholder": "Portugal",
      "value": _vm.location,
      "name": "location",
      "onChange": _vm.setLocation,
      "id": "locationSearch",
      "options": _vm.inputOptions,
      "label": "label"
    },
    on: {
      "update:value": function($event) {
        _vm.location = $event
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cf81b1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf81b1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SearchLocation.vue
// module id = 782
// module chunks = 3